import React from 'react'
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Upgradeprofile = () => {
  const { UserProfileID } = useSelector((state) => state.app);
  const navigate = useNavigate()
  const gotoPlanListing = () => {
    
    
    UserProfileID?.planUpgradeRequested ? toast.error( <>You have already made a request for upgradation !! <br />Admin will contact you shortly</>): navigate("/upgradeplan")
    // navigate("/upgradeplan")
  }
  return (
    <div className='viewsandebgagemntdiv'>
      <div className='viewsandebgagemntdpaddinf'>
        <div className=''>
          <p className='meettscysttxtpp'>Upgrade your plan to connect smarter and grow faster</p>
          <p className='wehelpsppeottxpp'>
          Join our Business Accelerator Network and unlock new opportunities for your business success
          </p>
        </div>
        <div className='trtysttxnowtrtysttxndiv'>
          <button className='trtysttxnowttxtp'>Try Now</button>
          <button className='ipyysffraedtn'
            onClick={(e) => gotoPlanListing()}
            disabled={!UserProfileID?.businessStatus}
            >
              Upgrade</button>
        </div>
      </div>
    </div>
  )
}

export default Upgradeprofile
